var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsTimelineActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20,
    transform: "matrix(0 1 1 0 4 4)",
    fill: "white",
    stroke: "#39B54A",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(0 1 1 0 12 12)",
    fill: "#39B54A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsTimelineActive);
export default __webpack_public_path__ + "static/media/ads-timeline-active.46e166ebaadc6178b8b8d15f2fbe4450.svg";
export { ForwardRef as ReactComponent };